export default "__VITE_ASSET__Cz09enK9__"